module.exports = __webpack_public_path__ + "img/ContactUs_Footer.bed33ed8.png";